import { createContext, useContext, useEffect, useState, useCallback } from "react";

const ThemeContext = createContext(null);
const STORAGE_KEY = "ambigara-theme";

function applyThemeClass(mode) {
  const root = document.documentElement;
  const setVar = (name, val) => root.style.setProperty(name, val);
  if (mode === "dark") {
    root.classList.add("dark");
    root.style.colorScheme = "dark";
    setVar("--background", "222 47% 5%");
    setVar("--foreground", "210 40% 96%");
    setVar("--card", "222 47% 8%");
    setVar("--card-foreground", "210 40% 96%");
    setVar("--popover", "222 47% 8%");
    setVar("--popover-foreground", "210 40% 96%");
    setVar("--muted", "217 33% 14%");
    setVar("--muted-foreground", "215 20% 65%");
    setVar("--border", "217 33% 17%");
    setVar("--input", "217 33% 17%");
    setVar("--brand-bg", "#0A0F1F");
    setVar("--brand-dark", "#E5E7EB");
  } else {
    root.classList.remove("dark");
    root.style.colorScheme = "light";
    ["--background","--foreground","--card","--card-foreground","--popover","--popover-foreground","--muted","--muted-foreground","--border","--input","--brand-bg","--brand-dark"]
      .forEach((n) => root.style.removeProperty(n));
  }
}

export function ThemeProvider({ children }) {
  const [mode, setMode] = useState(() => {
    try {
      const saved = localStorage.getItem(STORAGE_KEY);
      if (saved === "light" || saved === "dark") return saved;
    } catch { /* ignore */ }
    return "light";
  });

  useEffect(() => { applyThemeClass(mode); }, [mode]);

  const toggle = useCallback(() => {
    setMode((m) => {
      const next = m === "dark" ? "light" : "dark";
      try { localStorage.setItem(STORAGE_KEY, next); } catch { /* ignore */ }
      return next;
    });
  }, []);

  return (
    <ThemeContext.Provider value={{ mode, toggle, isDark: mode === "dark" }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  const ctx = useContext(ThemeContext);
  if (!ctx) throw new Error("useTheme must be inside ThemeProvider");
  return ctx;
}
